import {Component, input, output} from '@angular/core';
import {TableConfig} from '../table.interfaces';
import {FormsModule} from '@angular/forms';
import {NgFor} from '@angular/common';

@Component({
    selector: 'app-table-rowswitch',
    templateUrl: './table-rowswitch.component.html',
    styleUrl: './table-rowswitch.component.scss',
    imports: [FormsModule, NgFor]
})
export class TableRowswitchComponent {

    config = input.required<TableConfig>();
    readonly changeRows = output();

}
